import React, {Component, Fragment,} from 'react'
import {Form, Table,} from 'antd'
import {reqImportOrderVehicles,} from '../../api'

class ImportVehicleDriver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            vehicle: {},
            drivers: [],
        };
        this.columns = [
            {
                title: '姓名',
                dataIndex: 'name',
            }, {
                title: '手机',
                dataIndex: 'phone',
            }, {
                title: '身份证',
                dataIndex: 'identification',
            }
        ];
    }

    componentDidMount() {
        this.getVehicle();
    }

    getVehicle = async () => {
        const {orderId, type} = this.props;
        const result = await reqImportOrderVehicles({orderId, type});
        if (result.code === 200) {
            const vehicle = {
                id: result.data.id,
                orderId,
                truckNo: result.data.truckNo,
                supplierName: result.data.supplierName,
                weight: result.data.weight,
            };
            this.setState({vehicle, drivers: result.data.driverList});
        }
    };

    render() {
        const {type, entrustType} = this.props;
        const { vehicle, drivers} = this.state;
        return (
            <div className="vehicle-driver">
                <div className="vehicle-driver-head flex-between">
                    <div className="tab">{type === 'O' ? '境外' : '境内'}</div>
                    <div className="other"></div>
                </div>
                <div className="vehicle-driver-content">
                    <div className="title flex-between">
                        <div>车辆</div>
                    </div>
                    <Fragment>
                        <div>车牌号 : {vehicle.truckNo}</div>
                        <br/>
                        <div>车自重(吨): {vehicle.weight}</div>
                        <br/>
                        {entrustType === 'p2w' ? <div>供应商: {vehicle.supplierName}</div> : null}
                    </Fragment>
                    <div className="title flex-between">
                        <div>驾驶员</div>
                    </div>
                    <Table className='detail'
                           columns={this.columns}
                           bordered
                           pagination={false}
                           dataSource={drivers}
                           size="middle"/>
                </div>
            </div>
        )
    }
}

const VehicleDriverForm = Form.create()(ImportVehicleDriver);
export default VehicleDriverForm